<template>
  <div class="content">
    <div
      class="item-class"
      v-for="(item, index) of activityList"
      :key="item.id"
    >
      <div class="item-class-head">
        <div class="head--tip">
          <span class="one">{{ index + 1 }}</span>
          <span class="one two">F</span>
          <span class="item-class-title">{{ item.title }}</span>
        </div>
        <div class="head--category">
          <div
            :class="curIndex === ind ? 'cur' : ''"
            v-for="(val, ind) of item.cate"
            :key="val.id"
            @click="changeIndex(ind, index)"
          >
            {{ item.cate.length > 1 ? val.cate_name : "" }}
          </div>
        </div>
        <div class="head--all" @click="lookAll(item.cate_id)">
          <span>查看全部</span>
          <Icon type="android-arrow-dropright-circle" class="dropright"></Icon>
        </div>
      </div>
      <div class="detail-project">
        <div class="banner-img">
          <img :src="item.pic" alt="" />
        </div>
        <div
          class="item"
          v-for="element of item.productList"
          :key="element.id"
          @click="goDetail(element.id)"
        >
          <div class="head">
            <img v-lazy="element.image" alt="" />
          </div>
          <div class="bottom">
            <div class="title">{{ element.store_name }}</div>
            <div class="attr-content">
              <!-- <div class="price">￥{{ element.price }}</div> -->
              <!-- <div class="sale">销售: {{ element.sales }}件</div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="limit-banner" v-if="item.adv">
        <a :href="item.adv.url">
          <img :src="item.adv.pic" alt="" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductSpecial",
  props: ["activity", "advList"],
  data() {
    return {
      curIndex: 0,
      activityList: []
    };
  },
  watch: {
    activity: {
      handler() {
        this.activityList = this.activity;
        this.activityList.forEach((item, index) => {
          if (index <= this.advList.length) {
            this.activityList[index].adv = this.advList[index];
          }
        });

        this.activity.forEach((item, index) => {
          // 排除可能为空的情况
          if (!item.hasOwnProperty("cate")) {
            this.activityList.splice(index, 1);
            return;
          }
          this.activityList[index].productList = item.product[0];
        });
      }
    }
  },
  methods: {
    changeIndex(ind, index) {
      this.curIndex = ind;
      this.activityList[index].productList = this.activityList[index].product[
        ind
      ];
    },
    lookAll(id) {
      this.$router.push({
        path: "/goodsList",
        query: {
          cate_id: id
        }
      });
    },
    goDetail(id) {
      this.$router.push("/goodsDetail/" + id);
    }
  }
};
</script>

<style lang="stylus" scoped>
.content
  width 1200px
  margin 0px auto 20px
  .item-class
    width 100%
    margin-top 20px
    .item-class-head
      width 100%
      height 60px
      border-bottom 2px solid #0e86ff
      display flex
      .head--tip
        .one
          background #0e86ff
          display inline-block
          width 28px
          height 28px
          border-radius 14px 0 0 14px
          transform translateY(-3px)
          color #fff
          text-align center
          line-height 28px
          font-size 16px
        .two
          border-radius 0 14px 14px 0
          margin-left 2px
        .item-class-title
          font-family 'Microsoft yahei'
          font-size 24px
          line-height 60px
          color #333
          margin-left 16px
      .head--category
        display flex
        flex 1
        padding-top 12px
        margin-left 60px
        font-family 'Microsoft yahei'
        div
          height 34px
          line-height 34px
          font-size 16px
          cursor pointer
          margin 0 15px
          &.cur
            color #0e86ff
            border-bottom 2px solid #0e86ff
      .head--all
        font-size 16px
        position relative
        color #424242
        line-height 65px
        font-family 'Microsoft yahei'
        cursor pointer
        &:hover
          color #0e86ff
        .dropright
          margin-left 10px
          font-size 20px
          color #bbbbbb
          transform translateY(1px)
    .detail-project
      display flex
      flex-wrap wrap
      margin-bottom 30px
      .banner-img
        margin-top 15px
        margin-right 15px
        width 471px
        img
          width 100%
          height 100%
          object-fit cover
      .item
        background #fff
        width: calc(calc((100% - 60px) / 5));
        margin-right 15px
        margin-top 15px
        padding 15px
        &:hover
          cursor pointer
        &:nth-child(4)
          margin-right 0
        &:nth-child(9)
          margin-right 0
        .head
          width 200px
          height 200px
          text-align center
          margin 0 auto 10px
          img
            width 100%
            height 100%
        .bottom
          padding 5px 5px 0
          .title
            font-size 13px
            font-family 'Arial'
            color 333
            overflow hidden
            text-overflow ellipsis
            white-space nowrap
            height 26px
          .attr-content
            display flex
            justify-content space-between
            color #999
            .price
              color #ff5c4d
              font-size 16px
              font-family 'Microsoft yahei'
            .sale
              line-height 26px
              font-size 12px

  .item-class:nth-child(2)
    .item-class-head
      border-bottom 2px solid #33bc88
      .one
        background #33bc88
      .head--category
        div
          &.cur
            color #33bc88
            border-bottom 2px solid #33bc88

  .item-class:nth-child(3)
    .item-class-head
      border-bottom 2px solid #fb9259
      .one
        background #fb9259
      .head--category
        div
          &.cur
            color #fb9259
            border-bottom 2px solid #fb9259
</style>
